import SectionHeading from '@/components/base/SectionHeading';
import { showToast } from '@/components/base/Toast';
import { albumList } from '@/mocks/home';

const SPANS = [
  'sm:col-span-2 lg:col-span-2 lg:row-span-2',
  'sm:col-span-2 lg:col-span-2',
  'lg:col-span-1',
  'lg:col-span-1',
  'sm:col-span-2 lg:col-span-2',
];

export default function AlbumGrid() {
  return (
    <section id="albums" className="w-full border-y border-background-200 bg-background-100">
      <div className="w-full px-4 py-16 md:px-8 md:py-20">
        <div className="mx-auto max-w-[1200px]">
          <SectionHeading
            index="01"
            eyebrow="Photo Album"
            title="精选写真集"
            desc="以封面为主导的写真合集，收录制服、场景与主题三类定格画面，点开即可浏览完整图集。"
            actionLabel="查看更多写真集"
            onAction={() => showToast('静态展示：完整图集暂未开放')}
          />

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:auto-rows-[230px] lg:grid-cols-4">
            {albumList.map((album, index) => (
              <button
                key={album.id}
                type="button"
                onClick={() => showToast('静态展示：套图详情暂未开放')}
                className={`group relative block min-h-[280px] w-full overflow-hidden rounded-lg border border-background-300 bg-background-200 text-left ${SPANS[index] ?? ''}`}
              >
                <img
                  src={album.cover}
                  alt={`${album.title} - 善良的女秘书 写真集封面`}
                  title={`${album.title} - 善良的女秘书角色扮演 写真集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/15 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800">
                  {album.tag}
                </span>
                <span className="absolute right-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  {album.pages}P
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <h3 className="font-heading text-base font-bold text-background-50 md:text-lg">
                    {album.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-3 text-xs text-background-200">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line" />
                      {album.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-image-2-line" />
                      {album.pages} 张
                    </span>
                  </div>
                </div>
              </button>
            ))}

            <button
              type="button"
              onClick={() => showToast('静态展示：更多内容持续更新中')}
              className="group flex min-h-[280px] w-full flex-col items-start justify-center gap-4 rounded-lg border border-dashed border-primary-300 bg-primary-50 p-6 text-left transition-colors duration-200 hover:bg-primary-100 sm:col-span-2 lg:col-span-2"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-add-line text-2xl" />
              </span>
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  更多写真集持续补充
                </h3>
                <p className="mt-2 text-sm text-foreground-600">
                  每周新增角色扮演写真合集，涵盖制服、场景与主题多个方向。
                </p>
              </div>
              <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
                查看更新计划
                <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}